import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { ExitNote } from 'src/app/models/exit-note.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExitNoteService } from 'src/app/services/exit-note.service';

@Component({
  selector: 'app-exit-note',
  templateUrl: './exit-note.component.html',
  styleUrls: ['./exit-note.component.scss']
})
export class ExitNoteComponent {
  createNote: boolean = false;
  filterWord: string = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  notes: ExitNote[] = [];
  deletinfNoteId: number = null;
  loadingDelete: boolean = false;
  deleting: { [key: string]: boolean } = {};
  waitingFor = null;
  exitNote = null;
  showDetailsId = null;

  constructor(
    private ExitNoteService: ExitNoteService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getNotes();
  }

  getNotes() {
    this.ExitNoteService.getExitNotes().subscribe({
      next: (response: ResponseObject) => {
        this.notes = response.data;
        this.setNotes();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener las notas de salida', 'Error');
      }
    });
  }

  setNotes() {
    this.pagination.total = this.notes;
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  pageChange(event) {
    this.pagination.pageIndex = event.pageIndex;
    this.pagination.startElement = event.pageIndex * event.pageSize;
    this.pagination.filter = this.pagination.total.slice(this.pagination.startElement, this.pagination.startElement + event.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.pagination.total = this.notes.filter((note) => {
      return note.noteNumber.toString().toLowerCase().includes(this.filterWord)
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  closeCreateNote(created) {
    if (created) {
      this.getNotes();
    }
    this.createNote = false;
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  showDetails(note: ExitNote) {
    this.exitNote = note;
    this.showDetailsId = note.id;
  }

  closeDetails() {
    this.exitNote = null;
    this.showDetailsId = null;
  } 

  downloadNote(note: ExitNote) {
    // this.ExitNoteService.getExitNoteById(note.id).subscribe({
    //   next: (response: ResponseObject) => {
    //     const file = new Blob([response.data.pdf], { type: 'application/pdf' });
    //     const fileURL = URL.createObjectURL(file);
    //     window.open(fileURL);
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastService.error('Error al descargar la nota de salida', 'Error');
    //   }
    // });
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  confirmDelete(note: any) {
    if (this.deleting[note.id]) {
      return;
    }
    this.deleting[note.id] = true;
    this.waitingFor = null;
    this.ExitNoteService.deleteExitNote(note.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success('Nota de salida eliminada con éxito', 'Éxito');
        this.loadingDelete = false;
        this.deletinfNoteId = null;
        this.getNotes();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error('Error al eliminar la nota de salida', 'Error');
        this.loadingDelete = false;
        this.deletinfNoteId = null;
      }
    });
  }

  deleteNote(x: any) {
    this.waitingFor = x;
  }
}
